import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, HeaderItalic, Text } from '@/components/common';

interface ErrorStateProps {
  title?: string;
  message?: string;
  action?: { label: string; onClick: () => void };
}

export function ErrorState({ title, message, action }: ErrorStateProps) {
  const { t } = useTranslation('common');

  return (
    <Flex direction="column" align="center" gap="4" py="9" px="4">
      <AlertCircle size={48} color="gray" />
      <Flex direction="column" align="center" gap="1">
        <HeaderItalic size="4" align="center">
          {title ?? t('errors.generic')}
        </HeaderItalic>
        {message && (
          <Text size="2" color="gray" align="center">
            {message}
          </Text>
        )}
      </Flex>
      {action && <Button onClick={action.onClick}>{action.label}</Button>}
    </Flex>
  );
}

export type { ErrorStateProps };
